import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isLogin: false, // 登录状态
    authType: 2 // 登录类型
  },
  mutations: {
    storeUserLogin (state) {
      state.isLogin = true
    },
    storeUserLogout (state) {
      state.isLogin = false
      state.authType = 2
    },
    storeUserAuthType (state, authType) {
      state.authType = authType
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js